<div class="elementCont " id='ImageCont-{{indexofelement}}'>
    <div class="form-group form-group-custom-for-element">
        <img *ngIf="imagesrc!=null" src="{{imagesrc}}" #imageTag class="{{ this.height==null ? 'image-element-custom-form' : ''}}"  id="image-{{indexofelement}}"/>
    </div>
</div>